import { render, staticRenderFns } from "./PackagePayment.vue?vue&type=template&id=48b0afb9&scoped=true"
import script from "./PackagePayment.vue?vue&type=script&lang=js"
export * from "./PackagePayment.vue?vue&type=script&lang=js"
import style0 from "./PackagePayment.vue?vue&type=style&index=0&id=48b0afb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0afb9",
  null
  
)

export default component.exports